import {register} from '../vendor/theme-scripts/theme-sections';
import popupVideoSection from '../features/popup-video';

register('section-columns', popupVideoSection);
